import { Pagination,Table,Tooltip } from "antd";
import { Button } from "components/Button";
import { SkeltonLoader } from "components/skeltonLoader";
import { useEffect,useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatDateHandler2 } from "utils/common";
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";
import AddJobModal from "../../../../../../components/Administration/Jobs/ManageJobs/AddJobModal";
import Breadcrumbs from "../../../../../../components/Breadcrumbs";
import DeleteModal from "../../../../../../components/modelpopup/deletePopup";
import { useJob } from "../../context";

const ManageJobs = () => {
  const {
    loading,
    jobList,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleJobDetailPage,
    handleDateChange,
    createJobHandler,
    jobModal, setJobModal,
    setSelectedJob, selectedJob

  } = useJob();

  const { user, userLoading } = useSelector((state) => state.user);

  // Check if user has job_drive permission
  const hasJobDrivePermission = useMemo(() => {
    if (!user?.role?.permissions) return false;
    return user.role.permissions.some((p) => p.code === "job_drive") ||
           user?.modules?.some?.((m) => m.code === "job_drive");
  }, [user]);

  // Debug: Log permission check
  useEffect(() => {
    if (user?.role?.permissions) {
      const permissionCodes = user.role.permissions.map(p => p.code);
      console.log("ManageJobs - User permissions:", permissionCodes);
      console.log("ManageJobs - Looking for 'job_drive':", permissionCodes.includes("job_drive"));
      console.log("ManageJobs - Has job_drive permission:", hasJobDrivePermission);
    }
  }, [user, hasJobDrivePermission]);

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: true,
    },
    {
      title: "Job Title",
      dataIndex: "title",
      render: (text,record) => <Link to={`/manage-resumes?job=${record.id}`}>{text}</Link>,
      sorter: true,
    },

    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   render: (text) => (
    //     <Tooltip title={text}>
    //       <span className="truncate-text">{text.length > 100 ? `${text.substring(0, 100)}...` : text}</span>
    //     </Tooltip>
    //   ),
    //   // sorter: (a, b) => a.department.length - b.department.length,
    // },
    {
      title: "Department",
      dataIndex: "department",
      render: (text,record)=> (
        <div className="dropdown action-label text-center">
            <span className={`badge badge-soft-primary`}>{record?.department?.name || record?.department}</span>  

        </div>
      )
      // sorter: (a, b) => a.department.length - b.department.length,
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      sorter: true,
      render: (text) => <>{formatDateHandler2(text)}</>,
    },

    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      sorter: true,
      render: (text) => <>{formatDateHandler2(text)}</>,
    },
    {
      title: "Job Type",
      dataIndex: "jobtype",
      render: (text) => (
        <div className="dropdown action-label text-center">
            <span className={`badge badge-soft-warning`}>Full time</span>  

        </div>
      ),
      sorter: (a, b) => a.jobtype.length - b.jobtype.length,
    },
    {
      title: "Job Drive",
      dataIndex: "job_drive_enabled",
      render: (text, record) => (
        <div className="dropdown action-label text-center">
          {record.job_drive_enabled ? (
            <span 
              className="badge badge-soft-info"
              style={{
                fontSize: "12px",
                padding: "4px 10px",
                borderRadius: "4px",
                background: "rgba(211, 0, 26, 0.1)",
                color: "#D3001A",
                border: "1px solid rgba(211, 0, 26, 0.2)"
              }}
              title="Job Drive Enabled"
            >
              {/* <i className="la la-qrcode" style={{ fontSize: "10px", marginRight: "4px" }}></i>  */}
              Yes
            </span>
          ) : (
            <span className="badge badge-soft-secondary">No</span>
          )}
        </div>
      ),
      sorter: (a, b) => {
        const aValue = a.job_drive_enabled ? 1 : 0;
        const bValue = b.job_drive_enabled ? 1 : 0;
        return aValue - bValue;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => (
        <div className="dropdown action-label text-center">
          <span className={`badge badge-soft-${ text=="open" ?  "success" : "danger"}`}>{text}</span>
        </div>
      ),
      sorter: true,
    },
    // {
    //   title: "Vacancy",
    //   dataIndex: "application_count",
    //   render: (text) => (
    //     <span className={`badge badge-soft-danger`}>{text} Vacancy</span>  
    //     // <Link
    //     //   to="/app/administrator/job-applicants"
    //     //   className="btn btn-sm btn-primary"
    //     // >
    //     //   {text} Vacancy
    //     // </Link>
    //   ),
    //   sorter: (a, b) => a.application_count.length - b.application_count.length,
    // },
    {
      title: "Applicants",
      dataIndex: "applicant_count",
      render: (text,record) => (
         
        <Link
          to={`/manage-resumes?size=50&page=1&sort_by=&sort_type=&job=${record.id}&is_internal_referral=&nationality=`}
          // className="btn btn-sm btn-primary"
        >
          <span className={`badge badge-soft-primary`}>{text} Applicants</span> 
        </Link>
      ),
      sorter: (a, b) => a.applicant_count.length - b.applicant_count.length,
    },
    {
      title: "Action",
      render: (text , record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
            onClick={()=>{
              setJobModal(true)
              setSelectedJob(record)

            }}
              // to="#"
              className="dropdown-item"
              // data-bs-toggle="modal"
              // data-bs-target="#edit_job"
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <a
              href={`${window.location.origin}/job-view/${record.slug || record.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="dropdown-item"
            >
              <i className="fa fa-external-link m-r-5" /> View In Job Portal
            </a>
            {hasJobDrivePermission && record?.job_drive_enabled && (
              <Link
                to={`/job-drive/${record.id}`}
                className="dropdown-item"
              >
                <i className="fa fa-qrcode m-r-5" /> Job Drive Dashboard
              </Link>
            )}
            <Link
              to="#"
              className="dropdown-item"
              data-bs-toggle="modal"
              data-bs-target="#delete"
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {jobList.map((job, index) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-3"
              key={job.id}
              style={{
                marginBottom: "16px",
                display: "flex"
              }}
            >
              <div className="card shadow-sm" style={{ 
                borderRadius: "8px", 
                border: "none",
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                margin: 0,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                overflow: "visible",
                transition: "all 0.2s ease",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                cursor: "pointer"
              }}
              onClick={() => {
                setJobModal(true);
                setSelectedJob(job);
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
              }}
              >
                {/* Action Buttons - Top Right */}
                <div 
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    display: "flex",
                    gap: "4px",
                    zIndex: 10
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    onClick={() => {
                      setJobModal(true);
                      setSelectedJob(job);
                    }}
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "6px",
                      border: "none",
                      background: "rgba(59, 130, 246, 0.1)",
                      color: "#3b82f6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      fontSize: "14px"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#3b82f6";
                      e.currentTarget.style.color = "#fff";
                      e.currentTarget.style.transform = "scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "rgba(59, 130, 246, 0.1)";
                      e.currentTarget.style.color = "#3b82f6";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                    title="Edit Job"
                  >
                    <i className="la la-pencil" style={{ fontSize: "12px" }}></i>
                  </button>
                  <a
                    href={`${window.location.origin}/job-view/${job.slug || job.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "6px",
                      border: "none",
                      background: "rgba(34, 197, 94, 0.1)",
                      color: "#22c55e",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      fontSize: "14px",
                      textDecoration: "none"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#22c55e";
                      e.currentTarget.style.color = "#fff";
                      e.currentTarget.style.transform = "scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "rgba(34, 197, 94, 0.1)";
                      e.currentTarget.style.color = "#22c55e";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                    title="View Job Portal"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <i className="la la-external-link-alt" style={{ fontSize: "12px" }}></i>
                  </a>
                  {hasJobDrivePermission && job?.job_drive_enabled && (
                    <Link
                      to={`/job-drive/${job.id}`}
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "6px",
                        border: "none",
                        background: "rgba(211, 0, 26, 0.1)",
                        color: "#D3001A",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        fontSize: "14px",
                        textDecoration: "none"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#D3001A";
                        e.currentTarget.style.color = "#fff";
                        e.currentTarget.style.transform = "scale(1.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "rgba(211, 0, 26, 0.1)";
                        e.currentTarget.style.color = "#D3001A";
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                      title="Job Drive Dashboard"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className="la la-qrcode" style={{ fontSize: "12px" }}></i>
                    </Link>
                  )}
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedJob(job);
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#delete"
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "6px",
                      border: "none",
                      background: "rgba(239, 68, 68, 0.1)",
                      color: "#ef4444",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      fontSize: "14px",
                      textDecoration: "none"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#ef4444";
                      e.currentTarget.style.color = "#fff";
                      e.currentTarget.style.transform = "scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "rgba(239, 68, 68, 0.1)";
                      e.currentTarget.style.color = "#ef4444";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                    title="Delete Job"
                  >
                    <i className="la la-trash" style={{ fontSize: "12px" }}></i>
                  </Link>
                </div>

                <div className="card-body" style={{ 
                  padding: "16px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column"
                }}>
                  {/* Job Title */}
                  <div style={{
                    marginBottom: "12px"
                  }}>
                    <div
                      style={{
                        color: "#1f2937",
                        fontSize: "15px",
                        fontWeight: "600",
                        display: "block",
                        marginBottom: "8px",
                        lineHeight: "1.4"
                      }}
                    >
                      {job.title}
                    </div>
                    {job.description && (
                      <Tooltip title={job.description}>
                        <div style={{
                          fontSize: "12px",
                          color: "#6b7280",
                          lineHeight: "1.5",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          marginBottom: "10px"
                        }}>
                          {job.description}
                        </div>
                      </Tooltip>
                    )}
                  </div>

                  {/* Job Details */}
                  <div style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px"
                  }}>
                    {job.department && (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px"
                      }}>
                        <i className="la la-building" style={{ fontSize: "12px", color: "#9ca3af", width: "16px" }}></i>
                        <span style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                          {job.department?.name || job.department}
                        </span>
                      </div>
                    )}
                    
                    {job.created_at && (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px"
                      }}>
                        <i className="la la-calendar" style={{ fontSize: "12px", color: "#9ca3af", width: "16px" }}></i>
                        <span style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                          Created: {formatDateHandler2(job.created_at)}
                        </span>
                      </div>
                    )}

                    {job.expiry_date && (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px"
                      }}>
                        <i className="la la-calendar-times" style={{ fontSize: "12px", color: "#9ca3af", width: "16px" }}></i>
                        <span style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                          Expires: {formatDateHandler2(job.expiry_date)}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Badges */}
                  <div style={{
                    marginTop: "12px",
                    paddingTop: "12px",
                    borderTop: "1px solid #f0f0f0",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}>
                    <div style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                      alignItems: "center"
                    }}>
                      {job.vacancy && (
                        <span 
                          className="badge badge-soft-warning"
                          style={{
                            fontSize: "10px",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            fontWeight: "600"
                          }}
                        >
                          {job.vacancy} Vacancy
                        </span>
                      )}
                      {job.applicant_count !== undefined && (
                        <Link
                          to={`/manage-resumes?size=50&page=1&sort_by=&sort_type=&job=${job.id}&is_internal_referral=&nationality=`}
                          className="badge badge-soft-primary"
                          style={{
                            fontSize: "10px",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            fontWeight: "600",
                            textDecoration: "none"
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {job.applicant_count} Applicants
                        </Link>
                      )}
                    </div>
                    <div style={{ display: "flex", gap: "6px", alignItems: "center", flexWrap: "wrap" }}>
                      {hasJobDrivePermission && job.job_drive_enabled && (
                        <span 
                          className="badge badge-soft-info"
                          style={{
                            fontSize: "10px",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            fontWeight: "600",
                            background: "rgba(211, 0, 26, 0.1)",
                            color: "#D3001A",
                            border: "1px solid rgba(211, 0, 26, 0.2)"
                          }}
                          title="Job Drive Enabled"
                        >
                          <i className="la la-qrcode" style={{ fontSize: "9px", marginRight: "4px" }}></i>
                          Job Drive
                        </span>
                      )}
                      {job.status && (
                        <span 
                          className={`badge badge-soft-${job.status === "open" ? "success" : "danger"}`}
                          style={{
                            fontSize: "10px",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            fontWeight: "600",
                            flexShrink: 0
                          }}
                        >
                          {job.status}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Jobs"
            title="Dashboard"
            subtitle="Jobs"
            modal="#add_job"
            name="Add Job"
            view={view}
            setJobModal={setJobModal}
            setView={setView}
            isGrid={false}
            // hideGrid={true}
          />
          
          <style jsx>{`
            .truncate-text {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 100%;
              display: block;
            }
          `}</style>

          <div className="row">
            <div className="col-md-12">
            {view == "grid" ? (
                <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
            )
            : (
              <div className="row">
                <div className="col-12">
                  <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                    <style>{`
                      .modern-table .ant-table-tbody > tr {
                        background-color: #ffffff !important;
                      }
                      .modern-table .ant-table-tbody > tr:hover > td {
                        background-color: #f5f5f5 !important;
                      }
                      .modern-table .ant-table-thead > tr > th {
                        background-color: #f8f9fa !important;
                        font-weight: 600;
                        color: #333;
                        border-bottom: 2px solid #e0e0e0;
                        padding: 10px 12px;
                        font-size: 13px;
                      }
                      .modern-table .ant-table-tbody > tr > td {
                        border-bottom: 1px solid #f0f0f0;
                        padding: 10px 12px;
                        font-size: 13px;
                      }
                      .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                        border-top: 1px solid #f0f0f0;
                        background-color: #ffffff;
                        border-bottom-left-radius: 12px;
                        border-bottom-right-radius: 12px;
                      }
                    `}</style>
                    <div className="table-responsive" style={{ overflowX: "auto" }}>
                      <Table
                        className="mb-0 modern-table"
                        style={{ 
                          borderRadius: "12px",
                          minWidth: "100%"
                        }}
                        scroll={{ x: "max-content" }}
                        columns={columns}
                        dataSource={jobList}
                        rowKey={(record) => record.id}
                        loading={loading}
                        pagination={{
                          total: pageSettings?.total,
                          pageSize: pageSettings?.pageSize,
                          showSizeChanger: true,
                          pageSizeOptions: pageSizeOptions,
                          itemRender: itemRender,
                          position: "right",
                          current: pageSettings?.page,
                          showTotal: (total, range) =>
                            `${range[0]}-${range[1]} of ${total} items`,
                          style: { padding: "16px" }
                        }}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            </div>
          </div>
          <AddJobModal setSelectedJob={setSelectedJob} selectedJob={selectedJob} loading={loading} createJobHandler={createJobHandler} jobModal={jobModal} setJobModal={setJobModal} />
          {/* <EditJobModal /> */}
          <DeleteModal Name="Delete Job" />
        </div>
      </div>
    </>
  );
};

export default ManageJobs;
